"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var KeyedCollection = (function () {
    function KeyedCollection() {
        this.items = {};
        this.count = 0;
    }
    KeyedCollection.prototype.ContainsKey = function (key) {
        return this.items.hasOwnProperty(key);
    };
    KeyedCollection.prototype.Count = function () {
        return this.count;
    };
    KeyedCollection.prototype.Add = function (key, value) {
        if (!this.items.hasOwnProperty(key))
            this.count++;
        this.items[key] = value;
    };
    KeyedCollection.prototype.Remove = function (key) {
        delete this.items[key];
        this.count--;
        console.log("direct count", this.count);
    };
    KeyedCollection.prototype.Item = function (key) {
        return this.items[key];
    };
    KeyedCollection.prototype.Keys = function () {
        var keySet = [];
        for (var prop in this.items) {
            if (this.items.hasOwnProperty(prop)) {
                keySet.push(prop);
            }
        }
        return keySet;
    };
    KeyedCollection.prototype.Values = function () {
        var values = [];
        for (var prop in this.items) {
            if (this.items.hasOwnProperty(prop)) {
                values.push(this.items[prop]);
            }
        }
        return values;
    };
    return KeyedCollection;
}());
exports.KeyedCollection = KeyedCollection;
exports.SET_BET_VALUE = 'SET_BET_VALUE';
exports.RESET_BET_VALUE = 'RESET_BET_VALUE';



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/store/betting/types.ts
// module id = 2412
// module chunks = 5